import { ConfigurationFeatureFlag } from '@tink/config/src/tinkLinkConfig';
import { useConfiguration } from '../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { haveFeatureFlag } from '../models/configuration';

export const useConfigurationFeatureFlag = (flag: ConfigurationFeatureFlag) => {
  const { data: config } = useConfiguration();

  return haveFeatureFlag(config, flag);
};
